'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.assureData = assureData;

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _site = require('../context/site');

var _EntityMapper = require('./EntityMapper');

var _EntityMapper2 = _interopRequireDefault(_EntityMapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var DrupalPage = function (_React$Component) {
    (0, _inherits3.default)(DrupalPage, _React$Component);

    function DrupalPage() {
        (0, _classCallCheck3.default)(this, DrupalPage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DrupalPage.__proto__ || (0, _getPrototypeOf2.default)(DrupalPage)).apply(this, arguments));

        _this.state = { error: null };
        _this.lastAssuredProps = null;
        return _this;
    }

    (0, _createClass3.default)(DrupalPage, [{
        key: 'bootstrap',
        value: function bootstrap() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _ref, uuid;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return assureData(this.props);

                            case 2:
                                _ref = _context.sent;
                                uuid = _ref.uuid;

                                if (!(!this.props.mapper && !this.props.asyncMapper)) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 6:
                                return _context.abrupt('return', (0, _EntityMapper.assureComponent)({
                                    uuid: uuid,
                                    mapper: this.props.mapper,
                                    asyncMapper: this.props.asyncMapper,
                                    site: this.props.site
                                }));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
        /**
         * Checks if we can render sychronously from a set of props.
         * If the data isn't available yet, or if an async mapper is used of which the
         * component didn't load yet, we return false. Otherwise true.
         */

    }, {
        key: 'canRenderFromProps',
        value: function canRenderFromProps(props) {
            var uuid = props.site.getUuid(props.url);
            if (!uuid) return false;
            if (!this.props.mapper && !this.props.asyncMapper) return true;
            return (0, _EntityMapper.getComponentFromMapper)({
                uuid: uuid,
                mapper: this.props.mapper,
                asyncMapper: this.props.asyncMapper,
                site: this.props.site
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            var lastRequest = this.lastRequest = (0, _symbol2.default)();
            // If we can render from the current set of props, we need to change lastAssuredProps
            // to the current props. If the props change to something else that we can't render
            // from yet, we can always fallback to these props.
            if (this.canRenderFromProps(this.props)) {
                this.lastAssuredProps = this.props;
                return;
            }
            // Cache the props, we're going to async mode.
            var props = this.props;
            // If we can't render from props yet, we need to fetch our data and assure the mapper
            // is ready.
            (function () {
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    var _ref2, uuid;

                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return assureData(props);

                                case 2:
                                    _ref2 = _context2.sent;
                                    uuid = _ref2.uuid;

                                    if (!(lastRequest !== this.lastRequest)) {
                                        _context2.next = 6;
                                        break;
                                    }

                                    return _context2.abrupt('return');

                                case 6:
                                    if (!(props.mapper || props.asyncMapper)) {
                                        _context2.next = 9;
                                        break;
                                    }

                                    _context2.next = 9;
                                    return (0, _EntityMapper.assureComponent)({
                                        uuid: uuid,
                                        mapper: props.mapper,
                                        asyncMapper: props.asyncMapper,
                                        site: props.site
                                    });

                                case 9:
                                    if (!(lastRequest !== this.lastRequest)) {
                                        _context2.next = 11;
                                        break;
                                    }

                                    return _context2.abrupt('return');

                                case 11:
                                    if (this.canRenderFromProps(this.props)) {
                                        _context2.next = 13;
                                        break;
                                    }

                                    throw Error("The data can't be loaded from the DrupalPage component.");

                                case 13:
                                    // Now that these props are ready, we save them for later use.
                                    this.lastAssuredProps = this.props;
                                    // We need to do a force update, because we can now synchronously load them in the
                                    // render function.
                                    this.forceUpdate();

                                case 15:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
            })().catch(function (error) {
                // If an error occurs in the data fetching process, we want to throw that error during
                // the render. This way it can be catched by an ErrorBoundry.
                _this2.setState({ error: error });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.lastRequest = undefined;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.error) {
                throw this.state.error;
            }
            var canRenderFromProps = this.canRenderFromProps(this.props);
            // If we can't render from props, and we don't want to render while loading data,
            // we return null here. That unmounts the component from the mapper, and the
            // Layout component.
            if (!canRenderFromProps && !this.props.renderWhileLoadingData) {
                return null;
            }
            // If we can render based on the props, we do.
            // Otherwise, we get the last known loaded props from the component.
            var data = canRenderFromProps ? this.props : this.lastAssuredProps;
            // Is there isn't any data available to render (also not from before), we can only
            // render the layout.
            if (!data) {
                var PropLayout = this.props.layout;
                if (this.props.layout) {
                    return React.createElement(PropLayout, (0, _assign2.default)({ loadingData: true, url: null, page: null }, this.props.layoutProps));
                }
                // If there isn't a layout, we render nothing.
                return null;
            }
            var uuid = this.props.site.getUuid(data.url);
            var entityMapper = React.createElement(_EntityMapper2.default, { mapper: data.mapper, uuid: uuid, asyncMapper: data.asyncMapper, entityProps: (0, _assign2.default)({}, data.pageProps, { page: data.site.getData(uuid) }) });
            var Layout = this.props.layout;
            if (!Layout) {
                return entityMapper;
            }
            return React.createElement(Layout, (0, _assign2.default)({ loadingData: !canRenderFromProps, url: data.url, page: data.site.getData(uuid) }, data.layoutProps), entityMapper);
        }
    }]);
    return DrupalPage;
}(React.Component);

DrupalPage.propTypes = {
    asyncMapper: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOfType([PropTypes.object, PropTypes.func])]),
    layout: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    layoutProps: PropTypes.shape({}),
    mapper: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    pageProps: PropTypes.shape({}),
    renderWhileLoadingData: PropTypes.bool,
    url: PropTypes.string.isRequired
};
DrupalPage.defaultProps = {
    layout: undefined,
    layoutProps: {},
    pageProps: undefined,
    renderWhileLoadingData: false
};
var DrupalPageWrapper = React.forwardRef(function (props, ref) {
    return React.createElement(_site.SiteConsumer, null, function (site) {
        return React.createElement(DrupalPage, (0, _assign2.default)({}, props, { site: site, ref: ref }));
    });
});
function assureData(_ref3) {
    var url = _ref3.url,
        site = _ref3.site;

    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var uuid;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return site.getPage(url);

                    case 2:
                        uuid = _context3.sent;
                        return _context3.abrupt('return', { uuid: uuid, pageUuid: uuid });

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));
}
exports.default = DrupalPageWrapper;
//# sourceMappingURL=DrupalPage.js.map
